import { db } from './Firebase';
import { doc, increment, setDoc } from 'firebase/firestore/lite';

export function incrementProductStats(productId, field) {
    setDoc(
        doc(db, 'products', productId, 'stats', '0'),
        { [field]: increment(1) },
        { merge: true },
    );
}